import { createAction, props } from '@ngrx/store';
import { Video } from '../../core/models/video.model';

// Load videos for a leader
export const loadVideosByLeader = createAction(
  '[Videos] Load By Leader',
  props<{ leaderId: string }>()
);
export const loadVideosByLeaderSuccess = createAction(
  '[Videos] Load By Leader Success',
  props<{ leaderId: string; videos: Video[] }>()
);
export const loadVideosByLeaderFailure = createAction(
  '[Videos] Load By Leader Failure',
  props<{ error: string }>()
);

// Featured / continue watching
export const loadContinueWatching = createAction('[Videos] Load Continue Watching', props<{ userId: string }>());
export const loadContinueWatchingSuccess = createAction(
  '[Videos] Load Continue Watching Success',
  props<{ videos: Video[] }>()
);

// Update progress
export const updateVideoProgress = createAction(
  '[Videos] Update Progress',
  props<{ videoId: string; currentTime: number; duration: number; userId: string }>()
);
export const updateVideoProgressSuccess = createAction(
  '[Videos] Update Progress Success',
  props<{ videoId: string; currentTime: number }>()
);

// Remove from continue watching
export const removeFromContinueWatching = createAction(
  '[Videos] Remove From Continue Watching',
  props<{ videoId: string }>()
);
